<template>
    <div class="row">
        <div v-for="cont in contenidos" :key="cont.id" class="col-12 col-md-12 caja-vinculos"  :class="columnasContenido(cont.TamanoDeLaColumna)" >
          <router-link v-if="cont.AbrirEnVisor==false && cont.RutaDeArchivo != null && cont.RutaDeArchivo.includes('Micrositio')" :to="cont.RutaDeArchivo" class="vinculo"><h2>{{cont.TextoDelVinculo}}</h2></router-link>
          <a v-else-if="cont.AbrirEnVisor==false && cont.RutaDeArchivo != null && !cont.RutaDeArchivo.includes('themisfstest') && cont.RutaDeArchivo.includes('http')"  class="vinculo" target="_blank" :href="cont.RutaDeArchivo"><h2>{{cont.TextoDelVinculo}}</h2></a>        
          <a v-else-if="cont.AbrirEnVisor==false && cont.RutaDeArchivo != null && cont.RutaDeArchivo.includes('themisfstest')" v-on:click="AbrirArchivo(cont.RutaArchivoCarpeta,'_self')"   class="vinculo"><h2>{{cont.TextoDelVinculo}}</h2></a>
         <a v-else-if="cont.AbrirEnVisor==true && cont.RutaDeArchivo != null && cont.RutaDeArchivo.includes('themisfstest')" v-on:click="AbreElVisor(cont.RutaArchivoCarpeta)"  class="vinculo"><h2>{{cont.TextoDelVinculo}}</h2></a>
         <a v-else-if="cont.RutaArchivoCarpeta==null">{{cont.TextoDelVinculo}}</a>

 
        </div>

   </div>
</template> 

<script>
import comun from "@/../static/js/comun";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

export default {
    props:{
        contenidos:Array
    },
    methods:{
        columnasContenido(columnas){
            var respuesta = 'col-lg-'+columnas;
            return respuesta;
        },
         AbreElVisor: function(vinculo) {
          this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
       // this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
      
     AbrirArchivo: function(vinculo,forma) { 
      comun.DescargarDocumentoPDF(vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta));
          //  window.open(vinculo,forma);
        },
  
    }
}
</script>

<style  scoped>
.vinculo{
    display: flex;
    font-family: 'Myriad';
    text-align: center;
    align-items:center;
    justify-content:center;
    color: #FFF;
    background-color: rgba(34,34,34,.8);
    float: left;
    width: 100%;
    height: 80px;
  
    opacity: 0.8; 
  }

.vinculo h2 {
    color:white;
     font-family: 'Myriad';
    font-size: 2em;

  }

  
.vinculo h2:hover {
    font-size: 2.3em;
    transition: .6s all;
    }
      
.vinculo:hover{
    background-color: rgba(190,154,94,.9);
    }

.caja-vinculos{
  padding-bottom: 1vh;
  padding-top: 1vh;
}

</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/CajaConVinculo.vue